import { Checkbox } from "@mui/material";
import { UseEntityStore } from "../../common/entityStore";
import { UserCallCenterProjectEditDto, UserEditDto } from "./types";

export function UserCallCenterProjectEnabledControl({
    useUserStore,
    userCallCenterProjectDto,
}: {
    useUserStore: UseEntityStore<UserEditDto>;
    userCallCenterProjectDto: UserCallCenterProjectEditDto;
}) {
    return <>
        <Checkbox checked={userCallCenterProjectDto.isEnabled} onChange={() => {
            if (!userCallCenterProjectDto.isEnabled) {
                useUserStore.getState().setClientDataProp("userCallCenterProjects", [
                    ...useUserStore.getState().clientData.userCallCenterProjects,
                    { callCenterProjectId: userCallCenterProjectDto.callCenterProjectId }
                ]);
            } else {
                useUserStore.getState().setClientDataProp("userCallCenterProjects",
                    useUserStore.getState().clientData.userCallCenterProjects.filter(p =>
                        p.callCenterProjectId !== userCallCenterProjectDto.callCenterProjectId));
            }
        }} />
    </>;
}
